import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import DataTable from "../../../../../Common/DataTable/DataTable";
import {
  GET_ALL_RESERVATION_LIST_REQUEST,
  GET_ORDER_LIST_REQUEST,
} from "../../../../../Utils/Constant";
import { ReservationTableColumns } from "./TableColumn";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import { Eye, EllipsisVertical } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CommonDataTableFilterHeader from "../../../../../Common/DataTableHeader/CommonDataTableFilterHeader";
import { getBaseUrl } from "../../../../../Redux/Config/AppConfig";

const OrderTable = ({ statusFilter = "all", additionalFilters = {} }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const param = useParams();

  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalEntries, setTotalEntries] = useState(0);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [totals, setTotalsAmount] = useState({});
  const {
    orderList = [],
    addOrder,
    loading,
  } = useSelector((state) => state.order);
  // const [tablesList = []] = useSelector((state) => state.table)

  // useEffect(() => {
  //   if (addOrder?.success) {
  //     dispatch({
  //       type: GET_ALL_RESERVATION_LIST_REQUEST,
  //       payload: { page, limit: pageSize, sortBy, sortOrder },
  //     });
  //   }
  // }, [addOrder]);

  useEffect(() => {
    const payload = { 
      page, 
      limit: pageSize, 
      sortBy, 
      sortOrder,
    };

    // Add status filter
    if (statusFilter && statusFilter !== "all") {
      payload.status = statusFilter;
    }

    // Add additional filters from parent component
    Object.keys(additionalFilters).forEach(key => {
      if (additionalFilters[key] !== undefined && additionalFilters[key] !== null && additionalFilters[key] !== "") {
        payload[key] = additionalFilters[key];
      }
    });
    
    dispatch({
      type: GET_ORDER_LIST_REQUEST,
      payload,
    });
  }, [dispatch, page, pageSize, sortBy, sortOrder, statusFilter, additionalFilters]);

  const handleReservatrionByID = (id) => {
    dispatch({
      type: GET_ORDER_LIST_REQUEST,
      payload: { id },
    });
    // navigate(/reservation/add-room-booking/${reservation_id}?isViewOnly=true);
    navigate(`/restaurant/add-order?isViewOnly=true`);

    setOpenMenuId(null);
  };

  const ActionDropdown = ({ reservationStatus, reservation_id }) => {
    const [dropdownPosition, setDropdownPosition] = useState({
      top: 0,
      left: 0,
    });
    const [isValidPosition, setIsValidPosition] = useState(false);
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const hoverTimeoutRef = useRef(null);

    const calculatePosition = () => {
      if (!buttonRef.current) {
        setIsValidPosition(false);
        return false;
      }

      try {
        const rect = buttonRef.current.getBoundingClientRect();

        // Validate that we have a proper bounding rect
        if (!rect || rect.width === 0 || rect.height === 0) {
          setIsValidPosition(false);
          return false;
        }

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const dropdownWidth = 150;
        const dropdownHeight = 120;

        let top = rect.bottom + window.scrollY + 2;
        let left = rect.right + window.scrollX - dropdownWidth;

        // Boundary checks
        if (left < 0) {
          left = rect.left + window.scrollX;
        }
        if (left + dropdownWidth > viewportWidth) {
          left = viewportWidth - dropdownWidth - 10;
        }
        if (top + dropdownHeight > viewportHeight + window.scrollY) {
          top = rect.top + window.scrollY - dropdownHeight - 2;
        }

        // Final validation - ensure we don't have invalid positions
        if (top < 0 || left < 0 || isNaN(top) || isNaN(left)) {
          setIsValidPosition(false);
          return false;
        }

        setDropdownPosition({ top, left });
        setIsValidPosition(true);
        return true;
      } catch (error) {
        console.warn("Position calculation failed:", error);
        setIsValidPosition(false);
        return false;
      }
    };

    const handleMouseEnter = (e) => {
      e.stopPropagation();
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }

      // Only show dropdown if we can calculate a valid position
      if (calculatePosition()) {
        setOpenMenuId(reservation_id);
      }
    };

    const handleMouseLeave = () => {
      hoverTimeoutRef.current = setTimeout(() => {
        setOpenMenuId(null);
        setIsValidPosition(false);
      }, 150);
    };

    const handleDropdownMouseEnter = () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };

    const handleDropdownMouseLeave = () => {
      setOpenMenuId(null);
      setIsValidPosition(false);
    };

    // Cleanup timeout on unmount
    useEffect(() => {
      return () => {
        if (hoverTimeoutRef.current) {
          clearTimeout(hoverTimeoutRef.current);
        }
      };
    }, []);

    // Close dropdown if this component unmounts while open
    useEffect(() => {
      return () => {
        if (openMenuId === reservation_id) {
          setOpenMenuId(null);
        }
      };
    }, []);

    return (
      <div className="position-relative">
        <button
          ref={buttonRef}
          className="btn btn-sm"
          title="More actions"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <EllipsisVertical size={16} />
        </button>

        {openMenuId === reservation_id && isValidPosition && (
          <div
            ref={dropdownRef}
            className="position-fixed bg-white border rounded shadow-lg"
            style={{
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              zIndex: 2000,
              minWidth: "150px",
              maxWidth: "200px",
            }}
            onMouseEnter={handleDropdownMouseEnter}
            onMouseLeave={handleDropdownMouseLeave}
          >
            <div className="py-1">
              <button
                className="w-100 text-start border-0 bg-transparent px-3 py-2 d-flex align-items-center hover-bg-light"
                onClick={() => handleReservatrionByID(reservation_id)}
                style={{ fontSize: "14px" }}
              >
                <Eye size={14} className="me-2" />
                View
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };
  const handleView = (order) => {
    setSelectedOrder(order);
    console.log(order, "order");
    navigate(`/restaurant/edit-order/${order.id}?isViewOnly=true`);
  };

  const calculateTotals = (formData) => {
    const subtotal = formData.items.reduce(
      (sum, item) => sum + Number.parseFloat(item.total_price || 0),
      0
    );

    const serviceCharge = Number.parseFloat(formData.service_charge || 0);
    const tax = Number.parseFloat(formData.tax || 5);
    const discount = Number.parseFloat(formData.discount || 0);

    const serviceChargeAmount = (subtotal * serviceCharge) / 100;
    const taxAmount = ((subtotal + serviceChargeAmount) * tax) / 100;
    const discountAmount = (subtotal * discount) / 100;

    const tip = Number.parseFloat(formData.tip || 0);

    const total =
      subtotal + serviceChargeAmount + taxAmount - discountAmount + tip;

    return {
      id:formData?.id,
      subtotal,
      serviceChargeAmount,
      taxAmount,
      discountAmount,
      total,
      tip,
    };
  };

  // Payment handling function
  const handlePayAtCheckout = async (data) => {
    const totals = calculateTotals(data);
    setTotalsAmount(totals);
    await processPayment("pay_at_checkout", "pay_at_checkout", totals);
  };

  // Payment handling function
  const handlePayNow = async (data) => {
    if (data?.items) {
      const totals = calculateTotals(data);
      setTotalsAmount(totals);
      setShowPaymentModal(true);
    }
  };
  const processPayment = async (event, type, totalsData) => {
    setIsPaymentLoading(true);
    try {
      const baseUrl = getBaseUrl();
      const hotel_id= localStorage.getItem('hotel_id')   
      // Simplified payload with only required fields
      const paymentPayload = {
        order_id: totalsData ? totalsData?.id : totals?.id,
        method: paymentMethod,
        amount: totalsData ? totalsData?.total: totals.total,
        type: type || "pay_now",
        hotel_id
      };
      let token = localStorage.getItem("token");
      const response = await fetch(`${baseUrl}/order-payment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ← Add your token here
        },
        body: JSON.stringify(paymentPayload),
      });
      if (response.status === 201) {
        setShowPaymentModal(false);
        // Close modal and navigate
        setTimeout(() => {
          dispatch({
            type: GET_ORDER_LIST_REQUEST,
            payload: { page, limit: pageSize, sortBy, sortOrder },
          });
        }, 500);
      }
    } catch (error) {
      console.error("Payment processing failed:", error);
      alert("Payment processing failed. Please try again.");
    } finally {
      setIsPaymentLoading(false);
    }
  };
  useEffect(() => {
    const tableData = orderList?.data || [];
    const pagination = orderList?.pagination;
    // Filter by status if not 'all'
    const filteredData = statusFilter === "all"
      ? tableData
      : tableData.filter((table) => (table.status || "").toLowerCase() === statusFilter);
    const transformed = filteredData.map((table, index) => ({
      id: (currentPage - 1) * pageSize + index + 1,
      // guest:
      //   `${table.restaurant_user?.name}` ||
      //   `${table.guest?.first_name} ${table.guest?.last_name}` ||
      //   "-",
      guest: table?.guest_info?.name,
      table: table?.booking?.table?.name || "-",
      order_items: table?.items?.length || 0,
      service_charge: table?.service_charge || "-",
      discount: table?.discount || "-",
      total_amount: table?.total_amount || "0",
      status: (
        <span
          className={`btn btn-sm text-white ${
            table?.status === "open" ||
            table?.status === "active" ||
            table?.status === "completed"
              ? "bg-success"
              : table?.status === "cancelled"
              ? "bg-danger"
              : "bg-info"
          }`}
          style={{ textTransform: "capitalize" }}
          disabled
        >
          {table?.status}
        </span>
      ),
      comment: table?.comment || "-",
      actions: (
        <>
          {/* <button className="btn" onClick={() => handleOpenDelete(table)}>
            <i className="bi bi-trash text-danger"></i>
          </button> */}
          <button className="btn" onClick={() => handleView(table)}>
            <i className="bi bi-eye text-primary"></i>
          </button>
          {!table.payment_status && table?.status!=='completed' && (
            <>
              <button
                className="btn"
                onClick={() => handlePayNow(table)}
                title="Pay Now"
              >
                <i className="bi bi-cash-coin text-success"></i>
                {/* Pay Now */}
              </button>
              { table?.guest_type ==='hotel_guest' && table?.room_number_id &&
              <button
                className="btn"
                onClick={() => handlePayAtCheckout(table)}
                title="Pay At Checkout"
              >
                <i className="bi bi-clock-history text-info"></i>
                {/* Pay At Cheeckout */}
              </button>}
            </>
          )}
        </>
      ),
    }));

    setData(transformed);
    setTotalEntries(pagination?.totalResults || transformed?.length);
  }, [orderList, currentPage, pageSize, statusFilter]);

  const handleSortChange = (sort) => {
    setSortBy(sort.id);
    setSortOrder(sort.desc ? "desc" : "asc");
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const totalPages = Math.ceil(totalEntries / pageSize);

  return (
    <div>
      {/* <CommonDataTableFilterHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        setCurrentPage={setCurrentPage}
        // FilterOptions={FilterOptions}s
      /> */}

      <DataTable
        columns={ReservationTableColumns}
        data={data}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSortChange={handleSortChange}
        isLoading={loading}
      />
      <DataTableFooter
        currentPage={page}
        totalPages={totalPages}
        setCurrentPage={handlePageChange}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
      {/* Payment Modal */}
      {showPaymentModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-credit-card me-2"></i>
                  Complete Payment
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPaymentModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {/* Order Summary */}
                <div className="card mb-4">
                  <div className="card-header">
                    <h6 className="mb-0">Order Summary</h6>
                  </div>
                  <div className="card-body">
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td>Subtotal:</td>
                          <td className="text-end">
                            ₹{totals.subtotal.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Service Charge ({totals.service_charge}%):</td>
                          <td className="text-end">
                            ₹{totals.serviceChargeAmount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Tax ({totals.tax}%):</td>
                          <td className="text-end">
                            ₹{totals.taxAmount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Discount ({totals.discount}%):</td>
                          <td className="text-end">
                            -₹{totals.discountAmount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Tip:</td>
                          <td className="text-end">₹{totals.tip.toFixed(2)}</td>
                        </tr>
                        <tr className="table-active">
                          <td className="fw-bold">Total Amount:</td>
                          <td className="text-end fw-bold h5">
                            ₹{totals.total.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* Payment Method */}
                <div className="mb-4">
                  <label className="form-label">Payment Method</label>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="cash"
                          value="cash"
                          checked={paymentMethod === "cash"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="cash">
                          <i className="bi bi-cash me-2"></i>Cash
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="debit_card"
                          value="debit_card"
                          checked={paymentMethod === "debit_card"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="debit_card"
                        >
                          <i className="bi bi-credit-card me-2"></i>
                          Debit Card
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="credit_card"
                          value="credit_card"
                          checked={paymentMethod === "credit_card"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="credit_card"
                        >
                          <i className="bi bi-credit-card me-2"></i>
                          Credit Card
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="upi"
                          value="upi"
                          checked={paymentMethod === "upi"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="upi">
                          <i className="bi bi-phone me-2"></i>UPI
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="bank_transfer"
                          value="bank_transfer"
                          checked={paymentMethod === "bank_transfer"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="bank_transfer"
                        >
                          <i className="bi bi-globe me-2"></i>Bank Transfer
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowPaymentModal(false)}
                  disabled={isPaymentLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={processPayment}
                  disabled={isPaymentLoading}
                >
                  {isPaymentLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Processing Payment...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check-circle me-2"></i>
                      Complete Payment (₹{totals.total.toFixed(2)})
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderTable;
